






















































































































































































































































































































































































































































import baseUrl from '@/utils/envConfig'
import { Vue, Component } from 'vue-property-decorator'
import { exportJson2Excel } from '@/utils/excel'

import {
  resetObjValue2NoneString,
  downFile
} from '@/utils/tool'
import { getCookie } from '@/utils/cookies'
import { getVipPriceList,
  saveVipPrice,
  VipOn,
  VipOff,
  deletePrice } from '@/api/trade/trade'
import { Form } from 'element-ui'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'

const statusMap: any = new Map([[1, '上架'], [2, '下架'], [3, '删除']])

@Component({
  name: 'TradeVip'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    // udid: '',
    // payType: '',
    status: '1',
    // transactionNo: '',
    // createDateStart: '',
    // createDateEnd: '',
    page: 1,
    pageCount: 20
  }
  private formParams: any = {
    id: 0,
    unit: '',
    duration: '',
    name_rmb: '',
    name_usd: '',
    resign_count: '',
    amount_rmb: '',
    amount_usd: '',
    description_rmb: '',
    description_usd: '',
    regular_amount_rmb: '',
    regular_amount_usd: '',
    is_discount: 0,
    discount_amount_rmb: '',
    discount_amount_usd: '',
    discount_begin_time: '',
    discount_end_time: ''
  }
  // component data
  startEnd: string[] = []
  statusMap = statusMap
  validityTime = ''
  dateArrayExpire = ['', '']
  dateArrayPay = ['', '']
  tableLoading = false
  tableData: any[] = []
  selectedData: any[] = []
  totalCount = 0
  formVisible = false
  duration: string = ''
  // lifecycle
  created() {
    const { query } = this.$route
    if (query.status) {
      this.params.status = query.status as string
    }
    console.log(this.params.status)
    this.getTableData()
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    let res = await getVipPriceList(this.params)
    this.tableData = res.data.dataList
    this.totalCount = res.data.pageInfo.totalCount
    this.tableLoading = false
  }
  handleDateChange(date: string[]) {
    this.formParams.discount_begin_time = date && date[0]
    this.formParams.discount_end_time = date && date[1]
    console.log(this.formParams)
  }
  setParams(params: any) {
    let arr = []
    let ignoreList: string[] = ['page', 'pageCount']
    for (let key in params) {
      if (!ignoreList.includes(key)) {
        arr.push(key + '=' + params[key])
      }
    }
    return arr.join('&')
  }

  format(str: string) {
    if (str.length <= 0) return ''
    let [date] = str.split(' ')
    return date.replaceAll('-', '.')
  }

  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.dateArrayPay = ['', '']
    this.dateArrayExpire = ['', '']
    this.params.page = 1
    this.getTableData()
  }
  handleAdd() {
    this.formParams = {
      id: 0,
      unit: '',
      duration: '',
      name_rmb: '',
      name_usd: '',
      resign_count: '',
      amount_rmb: '',
      amount_usd: '',
      description_rmb: '',
      description_usd: '',
      regular_amount_rmb: '',
      regular_amount_usd: '',
      is_discount: 0,
      discount_amount_rmb: '',
      discount_amount_usd: '',
      discount_begin_time: '',
      discount_end_time: ''
    }
    this.formVisible = true
  }
  handleSelectionChange(list: any[]) {
    console.log(list)
    this.selectedData = list
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleChangeStatus(status: string) {
    this['$router'].push({
      query: {
        status
      }
    })
    this.getTableData()
  }

  handleEdit(item: any) {
    this.handleAdd()
    Object.keys(this.formParams).forEach(key => {
      if (item[key]) {
        this.formParams[key] = item[key]
      }
    })
    console.log(item)
    this.startEnd = [item.discount_begin_time, item.discount_end_time]
  }
  handleDelete(item: any) {
    console.log(item.id)
    this.$confirm('是否确认要删除?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        deletePrice({ ids: item.id }).then(res => {
          console.log(res)
          this.$message.success('操作成功')
          this.params.status = '3'
          this.handleChangeStatus('3')
        }).catch(() => {})
      })
      .catch(() => {})
  }
  handleOn(item: any) {
    console.log(item.id)
    this.$confirm('是否确认要上架?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        VipOn({ ids: item.id }).then(res => {
          console.log(res)
          this.$message.success('操作成功')
          this.params.status = '1'
          this.handleChangeStatus('1')
        }).catch(() => {})
      })
      .catch(() => {})
  }
  handleOff(item: any) {
    this.$confirm('是否确认要下架?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        VipOff({ ids: item.id }).then(res => {
          console.log(res)
          this.$message.success('操作成功')
          this.params.status = '2'
          this.handleChangeStatus('2')
        }).catch(() => {})
      })
      .catch(() => {})
  }
  handleManage(item: any, id: number) {
    this.tableLoading = true
    let manage: any[] = [this.handleEdit, this.handleOff, this.handleOn, this.handleDelete]
    console.log(item)
    console.log(id)
    manage[id](item)
  }
  handleOffAll() {
    let ids = this.selectIds
    VipOff({ ids }).then(res => {
      console.log(res)
      this.$message.success('操作成功')
      this.getTableData()
    }).catch(() => {})
  }
  handleOnAll() {
    let ids = this.selectIds
    VipOn({ ids }).then(res => {
      console.log(res)
      this.$message.success('操作成功')
      this.getTableData()
    }).catch(() => {})
  }
  handleDeleteAll() {
    let ids = this.selectIds
    deletePrice({ ids }).then(res => {
      console.log(res)
      this.$message.success('操作成功')
      this.getTableData()
    }).catch(() => {})
  }
  // close dialog, clear data
  handleFormClose() {
    this.cancelForm()
  }
  cancelForm() {
    (this.$refs['formParams'] as Form).resetFields()
    this.formVisible = false
  }
  checkParams() {
    let p = this.formParams
    if (p.name_rmb.trim().length <= 0) return '请输入套餐中文名称'
    if (p.name_usd.trim().length <= 0) return '请输入套餐英文名称'
    if ((!p.duration) && p.unit !== 'permanent') return '请选择时长'
    if (!p.unit) return '请选择时长单位'
    if (!p.amount_rmb) return '请输入价格（人民币）'
    if (!p.amount_usd) return '请输入价格（美元）'
    // if (!p.regular_amount_rmb) return '请输入老用户价格（人民币）'
    // if (!p.regular_amount_usd) return '请输入老用户价格（美元）'
    if (p.is_discount) {
      if (!p.discount_begin_time) return '请选择优惠活动开始时间'
      if (!p.discount_end_time) return '请选择优惠活动结束时间'
      if (!p.discount_amount_rmb) return '请输入活动价格（人民币）'
      if (!p.discount_amount_usd) return '请输入活动价格（美元）'
    }
    if (p.description_rmb.trim().length <= 0) return '请输入中文套餐说明'
    if (p.description_usd.trim().length <= 0) return '请输入英文套餐说明'
    return ''
  }
  confirmForm() {
    let result: string = this.checkParams()
    if (result.length) {
      return this.$message.warning(result)
    }
    saveVipPrice(this.formParams).then(res => {
      this.$message.success('操作成功')
      this.formVisible = false
      this.getTableData()
    }).catch(err => {
      console.log(err)
    })
  }
  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  get selectIds() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    return ids
  }
}
